<template>
  <v-container
      :fluid="true"
      fill-height
  >
    <v-layout justify-center align-center>
      <v-row>
        <v-spacer v-if="$vuetify.display.lgAndUp"/>
        <v-col md="12" lg="10">
          <p
              v-if="loading === false && items.length === 0"
              class="text-h6 text-center"
          >
            Cars not found
          </p>
          <v-list v-if="loading">
            <car-list-item-skeleton
                v-for="index in 10"
                :key="index"
                :index="index"
            />
          </v-list>
          <v-list v-else>
            <car-list-item
                v-for="(item, index) in items"
                :key="item"
                :id="item.id"
                :title="item.title"
                :subtitle="item.subtitle"
                :description="item.description"
                :index="index"
                :main-photo="item.mainPhoto"
                :first-price="numbers.formatMoney(item.prices.filter((currency) => currency.currency === Currency.KRW)[0].value, Currency.KRW)"
                :second-price="numbers.formatMoney(item.prices.filter((currency) => currency.currency === Currency.USD)[0].value, Currency.USD)"
                :third-price="numbers.formatMoney(item.prices.filter((currency) => currency.currency === Currency.EUR)[0].value, Currency.EUR)"
            />
          </v-list>
        </v-col>
        <v-spacer v-if="$vuetify.display.lgAndUp"/>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>

import CarListItem from "@/components/Car/CarListItem.vue";
import CarListItemSkeleton from "@/components/Car/CarListItemSkeleton.vue";
import {Currency} from "@/common/enum/currency";
import {numbers} from "@/common/numbers";

export default {
  name: "CarList",
  computed: {
    numbers() {
      return numbers
    },
    Currency() {
      return Currency
    },
  },
  components: {CarListItemSkeleton, CarListItem},
  props: {
    items: Array,
    loading: Boolean
  }
}
</script>

<style scoped>
</style>